import { render, staticRenderFns } from "./MUS001-Formulario.vue?vue&type=template&id=0d03d540&"
import script from "./MUS001-Formulario.vue?vue&type=script&lang=js&"
export * from "./MUS001-Formulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports